import React, { useState } from 'react';
import { Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { _global_buttonStyles } from '../../../../../../../common/ObjectStructures/Trasnversal';
import { showMessage } from '../../../../../../../common/Helpers';
import MessageBox from '../../../../../../Common/Message/MessageBox';
import PropTypes from 'prop-types';
import DataserieAssociacionChecks from './DataserieAssociacionChecks';
import { __MessageTypes } from '../../../../../../../common/Dictionaries';
import { useDispatch } from 'react-redux';
import { action_updateBoardContainerDataserieAssociation } from '../../../../../../../reducers/actions/KPI/actions';
import MessageBoxInfoComplex from '../../../../../../Common/Message/MessageBoxInfoComplex';
import { setBoardComponentContainer } from '../../../../../../../services/sKPI/board.service';


const SidePanelDataserieAssociation = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { 
        inputParam_BoardId = null,
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_DataSerieList = null,
        inputParam_ContainerId = null,
    } = props;

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    
    const [isValidForm, setIsValidForm] = useState({
        v1: true,
        v2: true,
        valueReal: true,
        valueProvisory: true,
        valueBudget: true,
        valueForecast: true,
    });
    
    const [objDataserieList, setObjDataserieList] = useState(inputParam_DataSerieList)

    const validateForm = () => {
        let isValid =(objDataserieList !== null && objDataserieList.length > 0) ? true : false;

        setIsValidForm(isValidForm)

        return isValid
    }

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        showMessage(setMessageConfig, false, null, null)

        setIsValidForm({
            v1: true,
            v2: true,
            valueReal: true,
            valueProvisory: true,
            valueBudget: true,
            valueForecast: true,
        });
    };

    const onSaveAssociations = () => {
        if (validateForm()) {
            setBoardComponentContainer(inputParam_BoardId, inputParam_ContainerId, objDataserieList.map((item, index) => {return item.dataserieId})).then((response) => {
                if (response.data.succeeded) {
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    dispatch(action_updateBoardContainerDataserieAssociation({ containerId: inputParam_ContainerId, objectList: objDataserieList }))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });

            onDismissPanel();
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-selectoneelement'))
        }
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        <PrimaryButton onClick={ onSaveAssociations } styles={_global_buttonStyles}>{ t('data-lang-btn-save') }</PrimaryButton>
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }  

    const onCheckboxCheckedChange = (event, checked, dataserie) => {
        let updatedList = [...objDataserieList];
    
        if (checked) {
            updatedList.push(dataserie);
        }
        else {
            updatedList = objDataserieList.filter((item, index, self) => {
                return (
                    self.findIndex((t) => t.dataserieId === item.dataserieId) === index
                );
            }).filter(x => x.dataserieId !== dataserie.dataserieId);
        }
        
        setObjDataserieList(updatedList);
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-updatecontainerdataseries') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-2">
                    <Col>
                        <MessageBoxInfoComplex inputParam_Width="100%" inputParam_Message={`${t('data-lang-msg-changedataseriescontainerassociation')}`} />
                    </Col>
                </Row>
                <Row className="pt-4">
                    <Col>
                        <div><b>{t('data-lang-lbl-availabledataseries')}</b></div>
                    </Col>
                </Row>
                <Row className="pt-2">
                    <Col>
                        <DataserieAssociacionChecks
                            inputParam_BoardId={inputParam_BoardId}
                            inputParam_DataSerieList={objDataserieList}
                            inputParam_OnCheckboxChange={onCheckboxCheckedChange}
                        />
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelDataserieAssociation.propTypes = {
    inputParam_BoardId: PropTypes.number.isRequired,
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_DataSerieList: PropTypes.array.isRequired,
    inputParam_ContainerId: PropTypes.number.isRequired,
};

export default SidePanelDataserieAssociation;